import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class RegistroCivilService {
  private http = inject(HttpService);

  public upload = async (body: any) => await this.http.post(`/v1/registro-civil/marco-folio-reverso`, body).then((response: any) => response.data);

  public list = async () => await this.http.get(`/v1/registro-civil/marco-folio-reverso`, false).then((response: any) => response.data.content.sort());

  public listSearchActos = async (queryParams: string = '') => await this.http.get(`/v1/registro-civil/buscar-acto?${queryParams}`, false).then((response: any) => response.data.content.sort());

  public searchSidea = async (body: any) => await this.http.post(`/v1/registro-civil/buscar-acto`, body).then((response: any) => response.data);

  // public reportSidea = async () => await this.http.get(`/v1/registro-civil/buscar-acto/report`).then((response: any) => response.data);

  public externoList = async () => await this.http.get(`/v1/registro-civil/externo`, false).then((response: any) => response.data.content.sort());
  public externoUpload = async (body: any) => await this.http.post(`/v1/registro-civil/externo`, body).then((response: any) => response.data);

  public digitalizacionList = async () => await this.http.get(`/v1/registro-civil/digitalizacion`, false).then((response: any) => response.data.content.sort());
  public digitalizacionUpload = async (body: any) => await this.http.post(`/v1/registro-civil/digitalizacion`, body).then((response: any) => response.data);

  public correccionActaList = async () => await this.http.get(`/v1/registro-civil/correccion-acta`, false).then((response: any) => response.data.content.sort());
  public correccionActaUpload = async (body: any) => await this.http.post(`/v1/registro-civil/correccion-acta`, body).then((response: any) => response.data);
}
